<template>
  <v-snackbar
      :timeout="snackbar.duration"
      bottom
      :min-width="300"
      :left="!$vuetify.breakpoint.mobile"
      v-model="snackbar.visible"
      :color="snackbar.color"
  >{{snackbar.message}}
  </v-snackbar>
</template>

<script>
import { SNACKS_DEFAULT_MILLIS } from '../../constants';

export default {
  name: 'InfoSnackbar',
  props: {
    snackbar: {
      type: Object,
      default: () => ({
        message: '',
        visible: false,
        color: '',
        duration: SNACKS_DEFAULT_MILLIS
      })
    }
  }
};
</script>

<style scoped>

</style>
